var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',[_c('template',{slot:"tabs"},[_c('router-view',{attrs:{"name":"tabs"}},[_c('template',{slot:"right"},[_c('router-view',{attrs:{"name":"tabsRight"}})],1)],2)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }